import React from 'react'
import Link from 'next/link'
import Trans from '../../atoms/Trans/Trans'

const SearchMenu = ({ result }) => {
  return (
    <div className="search-menu">
      <div className="search-menu__block">
        <p className="search-menu__title">
          <Trans chiave="Categorie suggerite" />
        </p>
        <div className="search-menu__list">
          {result?.categorie?.map((categoria, k) => (
            <Link legacyBehavior href={categoria?.url} key={k}>
              <a className="search-menu__item">
                {categoria?.titolo}
                {categoria?.parent_name && (
                  <span className="search-results__light">
                    {' '}
                    <Trans chiave="in" /> {categoria?.parent_name}
                  </span>
                )}
                {/* TODO aggiungere numeri prodotti {' '}<span className="search-menu__num-prod">(10)</span> */}
              </a>
            </Link>
          ))}
        </div>
      </div>
      {/* TODO aggiungere brands
      <div className="search-menu__block">
        <p className="search-menu__title">
          <Trans chiave="Marchi suggeriti" />
        </p>
        <div className="search-menu__list">

        </div>
      </div>*/}
    </div>
  )
}

export default SearchMenu
